import { Component, Input } from '@angular/core';
import { SelectOptionsService } from '../../shared/services/selectoptions.service';

@Component({
  selector: 'md-field-display',
  template: require('./fieldDisplay.component.html')
})

export class FieldDisplayComponent {
  @Input() fields;

  constructor(optionsService: SelectOptionsService) {
    this.optionsService = optionsService;

    this.valueMap = {
      // Account types
      'select-individual': 'Individual',
      'select-joint': 'Joint',
      'select-roth': 'Roth IRA',
      'select-traditional': 'Traditional IRA',
      'select-rollover': 'Rollover IRA',
      'select-custodial': 'Custodial',

      // Investment Objectives
      maximumGrowth: 'Maximum Growth',
      balanced: 'Balanced',
      growthAndIncome: 'Growth and Income',
      growth: 'Growth',
      speculation: 'Speculation',
      income: 'Income'
    };

    this.expanded = {};
  }

  fixOptionLevel(value) {
    const match = value.match(/^optionLevel(\d)$/);

    if (match !== null) {
      return `Level ${match[1]}`;
    }

    return value;
  }

  fixOptionsCodes(value, type) {
    return this.optionsService.getCodeName(type, value);
  }

  objKeys(obj) {
    const keys = Object.keys(obj);
    const optionsIndex = keys.indexOf('options');
    if (optionsIndex > -1) keys.splice(optionsIndex, 1);

    return keys;
  }

  iconClass(field) {
    const classes = {
      'review-icon': true,
      expanded: this.expanded[field] === true,
      collapsed: !this.expanded[field] !== true
    };

    return classes;
  }

  toggleSection(field) {
    this.expanded[field] = !this.expanded[field];
  }

  maskField(value, type) {
    let newValue = value;

    if (type === 'ssn') {
      newValue = newValue.replace(/^(\d){3}\-(\d){2}\-/, '*****');
    }

    if (type === 'full') {
      newValue = newValue.replace(/./g, '*'); // Replace literally every character with a *
    }

    return newValue;
  }

  // Filters for value formatting, could move this into a pipe at some point
  formatValue(value, optionsType, maskingType) {
    let newValue = value;

    // Boolean to Yes/No
    if (newValue === true || newValue === false) {
      return newValue ? 'Yes' : 'No';
    }

    // Data Value Mapping
    if (this.valueMap[newValue] !== undefined) return this.valueMap[newValue];

    // Special fix to extract option level
    newValue = this.fixOptionLevel(newValue);

    // Fix for select boxes with code mappings
    newValue = this.fixOptionsCodes(newValue, optionsType);

    // Data masking!
    newValue = this.maskField(newValue, maskingType);

    return newValue;
  }
}
